import gql from 'graphql-tag';

const DEALERSHIP_MEMBER_BID_FRAGMENT = gql`
  fragment DealershipMemberBidFragment on DealershipMemberBid {
    user_id
    dealer_id
    amount
    bidder_name
    bidder_email
    dealer_name
    bid_type
    status
  }
`;

export default DEALERSHIP_MEMBER_BID_FRAGMENT;
